import * as productServices from 'services/product';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CustomNotification } from 'common/components';

import { sleep } from 'utils/delay';
import { forwardTo } from 'utils/common/route';

import { qaAllergensKeys } from 'pages/qa-spec/components/qa-allergen/hooks';
import { useGetProductItemModules } from 'pages/product-full-view/components/product-new-detail-view/queries';

export const multiplePanelsAllergens = {
  productAllergens: (productId) => [
    'pim',
    'multiple-panels/allergens',
    parseInt(productId),
  ],
};

export const useGetProductAllergens = (productId) => {
  const queries = useQuery({
    queryKey: multiplePanelsAllergens.productAllergens(productId),
    queryFn: async () => {
      const response = await productServices.getProductAllergens({ productId });
      if (response?.isSuccess) {
        return response?.data;
      } else {
        CustomNotification.error(response?.message ?? 'Something went wrong!');
        forwardTo('/products');
      }
    },
    enabled: !!productId,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return {
    allergenGroups: queries?.data?.allergenGroups ?? [],
    ...queries,
  };
};

export const useSaveProductAllergens = (productId) => {
  const queryClient = useQueryClient();
  const { refetchDataProductModules } = useGetProductItemModules(
    productId,
    false //* isEnabled
  );

  return useMutation({
    mutationFn: productServices.saveProductAllergens,
    onSuccess: async (result) => {
      if (result?.isSuccess) {
        await sleep(1000);
        queryClient.invalidateQueries({
          queryKey: multiplePanelsAllergens.productAllergens(productId),
        });
        queryClient.invalidateQueries({
          queryKey: qaAllergensKeys.list(productId),
        });
        refetchDataProductModules();
      } else {
        CustomNotification.error(result?.message ?? 'Something went wrong!');
      }
    },
    onError: () => {
      CustomNotification.error('Something went wrong!');
    },
  });
};
